
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generic-landings",
      function () {
        return require("private-next-pages/generic-landings/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/generic-landings"])
      });
    }
  